import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'
import ResetPasswordEmailScreen from '../screens/ResetPasswordEmailScreen'
import { ensureUniversalLoginContext } from '@/utils/helpers/universalLoginContext.ts'

async function bootstrap() {
  await ensureUniversalLoginContext('reset-password-email')
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <ResetPasswordEmailScreen />
    </StrictMode>,
  )
}

bootstrap()
